export const returnDashIfNoValue = (value?: string | null): string => {
  if (!value || value === '' || /^ *$/.test(value)) {
    return '—';
  }
  return value;
};
